{
  "version": 1,
  "asset_id": "bda283a2-47f1-4e40-868b-94f43bd99531",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/bda283a2-47f1-4e40-868b-94f43bd99531/destination-roofing-crew-citrus-county-fl-480.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/bda283a2-47f1-4e40-868b-94f43bd99531/destination-roofing-crew-citrus-county-fl-480.webp",
  "original_filename": "destination-roofing-crew-citrus-county-fl-480.webp",
  "size": 26116,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:33Z"
}
